<div class="app" fxLayout="column">
  <app-toolbar-component *ngIf="displayToolbar$ | async"></app-toolbar-component>
  <router-outlet class="router-flex">
  </router-outlet>
</div>
